import React from "react";
import "@fortawesome/fontawesome-free/css/all.min.css";

/* ===== Fleet Images ===== */
const galleryData = [
  {
    id: 1,
    imgSrc: "/images/fleet/Honda-Amaze.jpg",
    title: "Honda Amaze",
  },
  {
    id: 2,
    imgSrc: "/images/fleet/Hyundai-Aura.jpg",
    title: "Hyundai Aura",
  },
  {
    id: 3,
    imgSrc: "/images/fleet/Hyundai-Xcent.jpg",
    title: "Hyundai Xcent",
  },
  {
    id: 4,
    imgSrc: "/images/fleet/Innova-Crysta.jpg",
    title: "Innova Crysta",
  },
  {
    id: 5,
    imgSrc: "/images/fleet/Kia-Carens.jpg",
    title: "Kia Carens",
  },
  {
    id: 6,
    imgSrc: "/images/fleet/Maruti-Ertiga.jpg",
    title: "Maruti Ertiga",
  },
  {
    id: 7,
    imgSrc: "/images/fleet/Mini-Bus.jpg",
    title: "Mini Bus",
  },
  {
    id: 8,
    imgSrc: "/images/fleet/Scorpio.jpg",
    title: "Scorpio",
  },
  {
    id: 9,
    imgSrc: "/images/fleet/Swift-Dzire.jpg",
    title: "Swift Dzire",
  },
  {
    id: 10,
    imgSrc: "/images/fleet/Tempo-Traveller.jpg",
    title: "Tempo Traveller",
  },
  {
    id: 11,
    imgSrc: "/images/fleet/Tourist-Special-Innova.jpg",
    title: "Tourist Special Innova",
  },
  {
    id: 12,
    imgSrc: "/images/fleet/Toyota-Corolla-Altis.jpg",
    title: "Toyota Corolla Altis",
  },
  {
    id: 13,
    imgSrc: "/images/fleet/Toyota-Etios.jpg",
    title: "Toyota Etios",
  },
  {
    id: 14,
    imgSrc: "/images/fleet/Urbania.jpg",
    title: "Urbania",
  },
];

/* ===== Fleet Cards ===== */
const fleetCards = [
 
    {
    title: "Honda Amaze",
    company: "Rising Cab Service",
    seater: "4+1",
    desc: "Comfortable sedan ideal for airport transfers, local travel and outstation trips.",
  },
  
  {
    title: "Hyundai Xcent",
    company: "Rising Cab Service",
    seater: "4+1",
    desc: "Reliable sedan offering smooth rides for city and corporate travel.",
  },

  {
    title: "Hyundai Xcent",
    company: "Rising Cab Service",
    seater: "4+1",
    desc: "Reliable sedan offering smooth rides for city and corporate travel.",
  },
  {
    title: "Swift Dzire",
    company: "Rising Cab Service",
    seater: "4+1",
    desc: "Popular sedan with spacious interiors and fuel-efficient performance.",
  },
  {
    title: "Toyota Etios",
    company: "Rising Cab Service",
    seater: "4+1",
    desc: "Comfortable and dependable sedan suitable for all travel needs.",
  },
  {
    title: "Toyota Corolla Altis",
    company: "Rising Cab Service",
    seater: "4+1",
    desc: "Premium sedan providing luxury, comfort and style.",
  },
  {
    title: "Maruti Ertiga",
    company: "Rising Cab Service",
    seater: "7+1",
    desc: "Spacious MPV perfect for family trips and group travel.",
  },
  {
    title: "Kia Carens",
    company: "Rising Cab Service",
    seater: "6+1",
    desc: "Premium family vehicle with stylish design and modern comfort.",
  },
  {
    title: "Innova Crysta",
    company: "Rising Cab Service",
    seater: "7+1",
    desc: "Luxury SUV offering premium comfort for business and family journeys.",
  },
  {
    title: "Tourist Special Innova",
    company: "Rising Cab Service",
    seater: "7+1",
    desc: "Designed especially for long-distance tours and sightseeing trips.",
  },
  {
    title: "Tempo Traveller",
    company: "Rising Cab Service",
    seater: "17+1",
    desc: "Best choice for group tours, corporate outings and family functions.",
  },
  {
    title: "Urbania",
    company: "Rising Cab Service",
    seater: "12+1",
    desc: "Premium luxury van offering superior comfort and spacious seating.",
  },
  // {
  //   title: "Mini Bus",
  //   company: "Rising Cab Service",
  //   seater: "25+1",
  //   desc: "Ideal for school trips, corporate events and large group transportation.",
  // },
];

export default function Booking({ cards = fleetCards }) {
  const getGalleryItem = (title) =>
    galleryData.find(
      (item) => item.title.toLowerCase() === title.toLowerCase()
    );

  const handleWhatsAppBooking = (title) => {
    const phone = "919272511548";

    const message = `Hello Rising Cab Service, I want to book ${title}. Please share more details.`;

    window.open(
      `https://wa.me/${phone}?text=${encodeURIComponent(message)}`,
      "_blank"
    );
  };

  return (
    <>
      {/* ===== Breadcrumb ===== */}
  <div
        className="breadcumb-wrapper"
        style={{
          backgroundImage: "url('./img/bg/breadcrumb-bg.jpg')",
          position: "relative",
        }}
      >
        <div
          style={{
            position: "absolute",
            inset: 0,
            backgroundColor: "rgba(0,0,0,0.3)",
            zIndex: 1, }}></div>

        <div className="container" style={{ position: "relative", zIndex: 2 }}>
          <div className="breadcumb-content">
            <h1 className="breadcumb-title">Online Booking</h1>
          </div>
        </div>
      </div>


 

      {/* ===== Fleet Section ===== */}
      <section
        className="taxi-rates-page section-space"
        style={{
          backgroundColor: "#f9fafc",
          padding: "80px 0",
        }}
      >
        <div className="container">
          <div className="row g-4 justify-content-center">
            {cards.map((c, idx) => {
              const galleryItem = getGalleryItem(c.title);

              return (
                <div className="col-xl-4 col-md-6 d-flex" key={idx}>
                  <div
                    className="taxi-card d-flex flex-column w-100"
                    style={{
                      borderRadius: "15px",
                      overflow: "hidden",
                      boxShadow: "0 10px 25px rgba(0,0,0,0.1)",
                    }}
                  >
                    {/* Vehicle Image */}
                    <div
                      style={{
                        background: "#4EA5DA",
                        padding: "20px",
                        textAlign: "center",
                      }}
                    >
                      <img
                        src={galleryItem?.imgSrc}
                        alt={c.title}
                        style={{
                          width: "100%",
                          height: "220px",
                          objectFit: "contain",
                        }}
                      />
                    </div>

                    {/* Content */}
                    <div
                      className="d-flex flex-column justify-content-between"
                      style={{
                        background: "#FF681A",
                        color: "#fff",
                        padding: "25px",
                        flex: 1,
                      }}
                    >
                      <div>
                        <h3
                          style={{
                            textAlign: "center",
                            color: "#fff",
                            marginBottom: "15px",
                          }}
                        >
                          {c.title}
                        </h3>

                        <p
                        className="text-white"
                          style={{
                            textAlign: "center",
                            marginBottom: "10px",
                            lineHeight: "1.6",
                          }}
                        >
                          {c.desc}
                        </p>

                        <p
                         className="text-white"
                          style={{
                            textAlign: "center",
                            fontWeight: "700",
                            fontSize: "18px",
                          }}
                        >
                          <i className="fas fa-users me-2"></i>
                          Seater: {c.seater}
                        </p>
                      </div>

                      <button
                        onClick={() => handleWhatsAppBooking(c.title)}
                        className="btn btn-success mt-3"
                        style={{
                          borderRadius: "50px",
                          padding: "12px",
                          fontWeight: "600",
                        }}
                      >
                        <i className="fab fa-whatsapp me-2"></i>
                        Book Now
                      </button>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </section>
    </>
  );
}